import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import MiniLogo_RF from "../../../../static/images/MiniLogo_RF.svg"

export class Sidebar extends Component {
  render() {
    const { menuItems } = this.props;
    var currentPath = this.props.location.pathname;

    return (
        <div className={`sidebar${this.props.className !== undefined ? ` ${this.props.className}` : ``}`}>
          <SimpleBar forceVisible="y" style={{ maxHeight: "100%", width: "100%" }}>
          <nav id="sidebar-menu">
            <ul>
              <li className="rf-logo">
                <img src={MiniLogo_RF} />
              </li>
              {menuItems &&
                menuItems.map((route, idx) => (
                  <li
                    key={`nav-route-${idx}`}
                    className={`${route.id}${
                      currentPath.indexOf(route.path) !== -1 ? " active" : ""
                    }`}
                  >
                    <Link to={route.path}>
                      <Fragment>
                        {route.icon !== undefined ? 
                          <div className={`logo`}>{route.icon}</div>
                          : <div className={`logo ${route.id}`}></div>
                        }
                        <p>{route.labelMobile}</p>
                      </Fragment>
                    </Link>
                  </li>
                ))}
            </ul>
          </nav>
          </SimpleBar>
        </div>
    );
  }
}

Sidebar.propTypes = {
  menuItems: PropTypes.array.isRequired,
};

export default withRouter(Sidebar);
